document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('variant-selects').forEach(function (picker) {
    const sectionId = picker.dataset.section;
    const dataScript = document.getElementById('VariantFilterData-' + sectionId);
    const form = document.getElementById('product-form-' + sectionId);

    if (!dataScript || !form) return;

    const productData = JSON.parse(dataScript.textContent);
    const variants = productData.variants || [];

    function getSelectedOptions() {
      const selected = [];

      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        selected[Number(input.dataset.optionIndex)] = input.value;
      });

      picker.querySelectorAll('select[data-option-index]').forEach(function (select) {
        selected[Number(select.dataset.optionIndex)] = select.value;
      });

      return selected;
    }

    function findSelectedVariant() {
      const selected = getSelectedOptions();

      return variants.find(function (variant) {
        return variant.available && selected.every(function (value, index) {
          return !value || variant.options[index] === value;
        });
      });
    }

    function filterDropdownOptions() {
      const selected = getSelectedOptions();

      picker.querySelectorAll('select[data-option-index]').forEach(function (select) {
        const optionIndex = Number(select.dataset.optionIndex);

        Array.from(select.options).forEach(function (option) {
          const optionValue = option.value;

          const exists = variants.some(function (variant) {
            if (!variant.available) return false;

            return variant.options.every(function (variantOption, index) {
              if (index === optionIndex) {
                return variantOption === optionValue;
              }

              if (selected[index]) {
                return variantOption === selected[index];
              }

              return true;
            });
          });

          option.hidden = !exists;
          option.disabled = !exists;
        });

        if (select.selectedOptions[0] && select.selectedOptions[0].hidden) {
          const firstAvailable = Array.from(select.options).find(function (option) {
            return !option.hidden && !option.disabled;
          });

          if (firstAvailable) {
            select.value = firstAvailable.value;
          }
        }
      });
    }

    function updateTechnicalMetafields() {
      const variant = findSelectedVariant();
      if (!variant || !variant.metafields) return;

      const data = variant.metafields;

      const propParois = document.getElementById('prop-nombre-parois');
      const propUv = document.getElementById('prop-traite-uv');
      const propTl = document.getElementById('prop-tl');

      if (propParois) propParois.value = data.parois || '';
      if (propUv) propUv.value = data.uv || '';
      if (propTl) propTl.value = data.tl || '';

      const displayParois = document.getElementById('display-nombre-parois');
      const displayUv = document.getElementById('display-traite-uv');
      const displayTl = document.getElementById('display-tl');

      if (displayParois) displayParois.textContent = data.parois || '';
      if (displayUv) displayUv.textContent = data.uv || '';
      if (displayTl) displayTl.textContent = data.tl || '';
    }

    function updateSelectedOptionLabels() {
      picker.querySelectorAll('input[type="radio"]:checked, select[data-option-index]').forEach(function (input) {
        const optionPosition = Number(input.dataset.optionIndex) + 1;
        const label = picker.querySelector('.selected-option-value[data-option-position="' + optionPosition + '"]');

        if (label) {
          label.textContent = input.value;
        }
      });
    }

    function refresh() {
      filterDropdownOptions();
      updateTechnicalMetafields();
      updateSelectedOptionLabels();
    }

    picker.addEventListener('change', function () {
      setTimeout(refresh, 100);
    });

    setTimeout(refresh, 300);
  });
});